import { render, staticRenderFns } from "./MenuDashBoardColaborador.vue?vue&type=template&id=3abaa6ee&scoped=true"
import script from "./MenuDashBoardColaborador.vue?vue&type=script&lang=js"
export * from "./MenuDashBoardColaborador.vue?vue&type=script&lang=js"
import style0 from "./MenuDashBoardColaborador.vue?vue&type=style&index=0&id=3abaa6ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abaa6ee",
  null
  
)

export default component.exports